import axios from 'axios'

export default {
    getProducts() {
        return axios.get('/api/products/lookup');
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/productselector/api.js